import React from 'react';
import ScrollCarousel from 'scroll-carousel-react';

import globe from './../../assets/images/static/globe.png';
import globeMob from './../../assets/images/static/globeMob.svg';

import { clients } from './ClientList';

import {
  ClientsContainer,
  HeadingTitle,
  GlobeSection,
  Image,
  ClientsCarousel,
  CarouselItems,
  ImgIcon,
} from './styled'

const OurClients = () => {

  return (
    <ClientsContainer>
      <HeadingTitle>Our Clients</HeadingTitle>
      <GlobeSection>
        <Image
          src={globe}
          alt="Our Clients"
          className='hideonMobile'
        />
        <Image
          src={globeMob}
          alt="Our Clients"
          className='showonMobile'
        />
      </GlobeSection>
      <ClientsCarousel>
        <ScrollCarousel
          autoplay={true}
          autoplaySpeed={1}
          speed={1}
          direction='ltr'
        >
        {
          clients.map((list) => (
            <CarouselItems key={list.id}>
              <ImgIcon src={list.source} alt={list.title} />
            </CarouselItems>
          ))
        }
        </ScrollCarousel>
      </ClientsCarousel>
    </ClientsContainer>
  );
}

export default OurClients;